import { render } from "./DraggableModal.vue?vue&type=template&id=4e720ac8&scoped=true&ts=true"
import script from "./DraggableModal.vue?vue&type=script&lang=ts"
export * from "./DraggableModal.vue?vue&type=script&lang=ts"

import "./DraggableModal.vue?vue&type=style&index=0&id=4e720ac8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e720ac8"]])

export default __exports__